import { render, staticRenderFns } from "./bomeffective.vue?vue&type=template&id=79bfa414&scoped=true&"
import script from "./bomeffective.vue?vue&type=script&lang=js&"
export * from "./bomeffective.vue?vue&type=script&lang=js&"
import style0 from "./bomeffective.vue?vue&type=style&index=0&id=79bfa414&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bfa414",
  null
  
)

export default component.exports